<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">สรุปข้อมูลยอดขาย</h1>
          <p class="text-white pb-3 px-3">
            สรุปรายการยอดขายในแต่ละวันของพนักงานขาย
          </p>
        </div>
        <div
          class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <h1 class="display-3 text-white">
            <small>ยอดรวมทั้งหมด :</small>
            {{ total | numFormat("0,0.00") }}
            <small>บาท</small>
          </h1>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--8 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-lg-6">
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาวันที่ขายสินค้า (วันเริ่มต้น - วันสุดท้าย)"
                    label-for="input-1"
                    class="mb-0">
                    <div class="row align-self-center">
                      <div class="col-lg-6">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd-mm-yyyy' }"
                          v-model="filters">
                        </date-range-picker>
                      </div>
                      <div class="col-lg-4 px-0">
                        <b-form-input
                          v-model="filter"
                          type="text"
                          placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                      </div>
                      <div class="col-lg-2">
                        <button
                          class="btn btn-info btn-sm-res"
                          v-on:click="getOrder(false)">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
                <div class="col-lg-2">
                  <b-form-group
                    id="input-group-1"
                    label="ตัวกรอง"
                    label-for="input-1"
                    class="mb-0">
                    <select class="form-control" v-model="filterStatus">
                      <option :value="null">
                        {{ "ดูสถานะทั้งหมด" }}
                      </option>
                      <option
                        :value="status.key"
                        v-for="status in dataStatus"
                        :key="status.key">
                        {{ status.title }}
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-lg-2">
                  <b-form-group
                    id="input-group-2"
                    label="ผู้ออกบิล"
                    label-for="input-2"
                    class="mb-0">
                    <select class="form-control" v-model="filterUserCreate">
                      <option :value="null">
                        {{ "ผู้ออกบิลทั้งหมด" }}
                      </option>
                      <option
                        :value="user"
                        v-for="(user, index) in dataUserCreate"
                        :key="index">
                        {{ user }}
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-lg-2">
                  <b-form-group label="Export File" class="mb-0 pb-2">
                    <div
                      class="btn-group btn-sm-res btn-export"
                      role="group"
                      aria-label="Basic example">
                      <!-- <vue-excel-xlsx
                        :data="order"
                        :columns="column"
                        :filename="`สรุปข้อมูลยอดขาย ${date_excel}`"
                        :sheetname="`สรุปข้อมูลยอดขาย ${date_excel}`">
                        excel
                      </vue-excel-xlsx> -->
                      <ExportExcel
                        :columns="column"
                        :getData="formatExcel"
                        :name="`สรุปข้อมูลยอดขาย ${date_excel}`"
                        :disabled="totalItem == 0">
                      </ExportExcel>
                      <b-button
                        variant="info btn-sm-res"
                        @click="$htmlToPaper('tablePrint')"
                        >print</b-button
                      >
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div id="tablePrint" style="position: relative">
              <b-table
                show-empty
                empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย"
                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                :items="filterOrder"
                :fields="fields"
                :filter="filter"
                responsive
                :busy="busy"
                :per-page="search.perPage"
                class="scroll-bar-pop m-h-inherit table-min-500"
                outlined>
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="index" slot-scope="data">{{
                  getOverAllIndex(data.index)
                }}</template>
                <template slot="purchase_id" slot-scope="row">
                  <b-badge :variant="statusOrder(row.item.purchase_id).color">
                    {{ statusOrder(row.item.purchase_id).status }}
                  </b-badge>
                </template>
                <template slot="receipt_no" slot-scope="row">
                  <router-link tag="a" :to="`/cancelorders/${row.item.id}`">
                    <u>{{ row.item.receipt_no }}</u>
                  </router-link>
                </template>
                <template slot="num_all_parcel" slot-scope="row">{{
                  row.item.num_all_parcel
                }}</template>
                <template slot="ship_price" slot-scope="row">{{
                  row.item.ship_price | numFormat("0,0.00")
                }}</template>
                <template slot="item_price" slot-scope="row">{{
                  row.item.item_price | numFormat("0,0.00")
                }}</template>
                <template slot="ship_fee" slot-scope="row">{{
                  row.item.ship_fee | numFormat("0,0.00")
                }}</template>
                <template slot="total" slot-scope="row">{{
                  row.item.total | numFormat("0,0.00")
                }}</template>
                <template slot="discount" slot-scope="row">{{
                  row.item.discount | numFormat("0,0.00")
                }}</template>
                <template slot="balance" slot-scope="row">{{
                  row.item.balance | numFormat("0,0.00")
                }}</template>
                <template slot="manage" slot-scope="row">
                  <div class="text-center">
                    <base-dropdown :position="'right'">
                      <template slot="title">
                        <i class="fas fa-ellipsis-h"></i>
                      </template>
                      <!-- <router-link
                        class="dropdown-item"
                        :to="`/cancelorders/${row.item.id}`">
                        ดูรายละเอียดรายการ
                      </router-link> -->
                      <a
                        :class="
                          row.item.purchase_id < 0 ? 'disabled text-muted' : ''
                        "
                        class="dropdown-item"
                        @click="printReceipt(row.item.id)">
                        พิมพ์ใบเสร็จ
                      </a>
                      <router-link
                        class="dropdown-item"
                        :class="
                          row.item.purchase_id < 0 ? 'disabled text-muted' : ''
                        "
                        :to="`/receipt/${row.item.id}`"
                        target="_blank">
                        ดูใบเสร็จ
                      </router-link>
                    </base-dropdown>
                  </div>
                </template>
              </b-table>
              <div class="mt-3">
                <b-pagination
                  :total-rows="totalItem"
                  :current-page="search.page"
                  :per-page="search.perPage"
                  :value="search.page"
                  @input="changePage"
                  align="right">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js";
import BtnLabel from "@/components/custom/printLabel/BtnLabel";
import moment from "moment";
import { statusOrder } from "@/plugins/statusOrder.js";
import ExportExcel from "@/components/custom/exportExcel/ExportExcel";

const API_URL = process.env.VUE_APP_API;
export default {
  name: "page-visits-table",
  components: {
    BtnLabel,
    ExportExcel,
  },
  data() {
    return {
      page: {
        pageCurrent: 0,
        btnLoadmore: false,
        btnLoading: false,
      },
      search: {
        page: 1,
        perPage: 20,
      },
      totalItem: 0,
      order: [],
      date: new Date(),
      busy: false,
      sortBy: "created_at",
      sortDesc: true,
      message: "Loading",
      column: [
        {
          label: "วันที่สร้างรายการ",
          field: "created_at",
          dataFormat: (value) => {
            return `${this.$options.filters.dateFormat(value)}`;
          },
        },
        {
          label: "รหัสรายการ",
          field: "receipt_no",
        },
        {
          label: "จำนวนพัสดุ",
          field: "num_all_parcel",
        },
        {
          label: "ค่าขนส่ง",
          field: "ship_price",
        },
        {
          label: "ค่าสินค้า",
          field: "item_price",
        },
        {
          label: "ค่าบริการ",
          field: "ship_fee",
        },
        {
          label: "ผู้ส่ง",
          field: "sender_name",
        },
        {
          label: "ผู้ออกบิล",
          field: "user_create",
        },
        {
          label: "ยอดรวม",
          field: "total",
        },
        {
          label: "ส่วนลด",
          field: "discount",
        },
        {
          label: "ยอดสุทธิ",
          field: "balance",
          dataFormat: (value) => {
            return `${this.$options.filters.numFormat(value, "0,0.00")}`;
          },
        },
      ],
      fields: [
        { key: "index", label: "#", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "receipt_no", label: "รหัสรายการ", sortable: true },
        {
          key: "purchase_id",
          label: "สถานะ",
          sortable: true,
          class: "text-cneter",
        },
        { key: "num_all_parcel", label: "จำนวนพัสดุ", sortable: true },
        { key: "ship_price", label: "ค่าขนส่ง", sortable: true },
        { key: "item_price", label: "ค่าสินค้า", sortable: true },
        { key: "ship_fee", label: "ค่าบริการ", sortable: true },
        { key: "sender_name", label: "ผู้ส่ง", sortable: true },
        { key: "user_create", label: "ผู้ออกบิล", sortable: true },
        { key: "total", label: "ยอดรวม" },
        { key: "discount", label: "ส่วนลด" },
        { key: "balance", label: "ยอดสุทธิ" },
        { key: "manage", label: "การจัดการ" },
      ],
      filter: null,
      dateExp: "",
      userLogin: "",
      filters: {
        startDate: "",
        endDate: "",
      },
      date_excel: moment().format("DD-MM-YYYY"),
      modal: {
        idDel: "",
        msgBody: "success",
      },
      errorSys: {
        apiErrGetOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #001",
        apiErrDelOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #002",
        apiErrPrintOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #003",
      },
      statusOrder: statusOrder,
      filterStatus: null,
      filterUserCreate: null,
      dataStatus: [
        { key: "1", title: "SUCCESS" },
        { key: "-3", title: "CANCEL" },
      ],
      dataUserCreate: [],
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.getDateNow(this.date);
    this.getOrder();
  },
  methods: {
    async formatExcel() {
      try {
        const res = await this.getOrderApi(true);
        return res.data.data.data.data;
      } catch (err) {
        console.log("formatExcel => ", err);
      }
    },
    deleteOrder() {
      let id = this.modal.idDel;
      this.$http
        .delete(API_URL + "/shop/order/" + id, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("ลบข้อมูลสำเร็จ");
          this.getOrder();
        })
        .catch((error) => {
          this.showErrorModal(this.errorSys.apiErrDelOrder);
        });
    },
    changePage(i) {
      if (this.search.page == i) return;
      this.search.page = i;
      this.getOrder();
    },
    async getOrderApi(load_all = false) {
      let dateStart = moment(this.filters.startDate).format("YYYY-MM-DD");
      let dateEnd = moment(this.filters.endDate).format("YYYY-MM-DD");
      return await this.$http.get(
        API_URL + "/orders?date_start=" + dateStart + "&date_end=" + dateEnd,
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
          params: {
            page: this.search.page,
            load_all,
          },
        }
      );
    },
    async getOrder() {
      this.busy = true;
      try {
        const res = await this.getOrderApi();
        let checkError = validatePop(res);
        if (!checkError.status) {
          if (checkError.notices == "token is expired") {
            this.$router.push("/logout");
          }
          this.showErrorModal(checkError.msg);
          throw checkError.msg;
        }
        this.order = res.data.data.data.data;
        this.dataUserCreate = [
          ...new Set(
            this.order
              .map((item) => item.user_create)
              .filter((value, index, self) => self.indexOf(value) === index)
          ),
        ];
        this.dateExp = this.$options.filters.dateFormat(
          res.data.data.expired_date
        );
        this.totalItem = res.data.data.data.total_item;
        this.search.perPage = res.data.data.data.per_page;
      } catch (err) {
        console.log(err);
        this.showErrorModal(this.errorSys.apiErrGetOrder);
      } finally {
        this.busy = false;
      }
    },
    printReceipt(id) {
      this.$http
        .get(API_URL + `/order/${id}/receipt`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          const win = window.open("");
          let html = res.data.data;
          win.document.write(html);
          setTimeout(() => {
            win.document.close();
            win.focus();
            win.print();
            win.close();
          }, 100);
        })
        .catch((error) => {
          this.showErrorModal(this.errorSys.apiErrPrintOrder);
        });
    },
    sendLabel(id) {
      this.$router.push(`/label/${id}/${this.sizeLabel.code}`);
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    getDateNow(myDate) {
      var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
      var date = ("0" + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      var formattedDate = year + "-" + month + "-" + date;
      this.filters.startDate = formattedDate;
      this.filters.endDate = formattedDate;
    },
    showComfirmModal() {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบรายการ `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteOrder();
          }
        });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    setTypeUrlLabel(id, size, dropoff) {
      let url = `#/label/${id}/${size}`;
      if (dropoff) {
        url = url + "/dropoffShippop";
      }
      return url;
    },
    getOverAllIndex(index) {
      return (
        this.search.page * this.search.perPage - this.search.perPage + index + 1
      );
    },
  },
  computed: {
    filterOrder() {
      let res = [];
      if (this.filterStatus === null && this.filterUserCreate === null) {
        res = this.order;
      } else if (this.filterStatus && this.filterUserCreate) {
        res = this.order.filter((detail) => {
          return (
            String(detail.purchase_id) === String(this.filterStatus) &&
            String(detail.user_create) === String(this.filterUserCreate)
          );
        });
      } else if (this.filterStatus) {
        res = this.order.filter((detail) => {
          return String(detail.purchase_id) === String(this.filterStatus);
        });
      } else if (this.filterUserCreate) {
        res = this.order.filter((detail) => {
          return String(detail.user_create) === String(this.filterUserCreate);
        });
      }

      return res;
    },
    total() {
      return this.order.reduce((total, product) => {
        return total + Number(product.total);
      }, 0);
    },
  },
};
</script>
